'use strict';

import controller from './formularios.controller';
import template from './formularios.html';
import './formularios.scss';

const FormulariosGeneradosComponent = {
  bindings: {
    proyecto: '='
  },
  controller,
  template
};

export default FormulariosGeneradosComponent;



// WEBPACK FOOTER //
// ./src/app/components/empresas/c-empresas/formularios-generados/formularios.component.js